<template>
  <div v-if="((selectedShipmentArray.length > 0) && (selectedShipmentArray.length <= 5) && (selectedShipment == 'Current'))" class="button-container">
    <div class="count-selected">
        <!-- <p>You can select up to 5 shipments.</p> -->
        <p><span>{{selectedShipmentArray.length}}</span> shipment(s) selected.</p>
    </div>
  </div>
  <div v-if="((selectedShipmentArray.length > 0) && (selectedShipmentArray.length <= 5) && (selectedShipment == 'Current'))" class="button-container">
    <div class="print-selected">
        <p class="print-selected-text" @click="PrintLabel()">Print Label</p>
    </div>
    <div class="void-selected">
        <p class="void-selected-text" @click="VoidShipment()">Void Shipment</p>
    </div>
    <!-- <div v-if="labelData != null" class="print-selected close-label">
        <p class="print-selected-text" @click="closeLabel(); labelData = null; selectedShipmentArray = []">Close Label</p>
    </div> -->
    <div v-if="(renderSignedLabelURLs.length > 0) && showPdfRenderer" class="print-selected close-label">
        <p class="print-selected-text" @click="closeLabel(); renderSignedLabelURLs = []; selectedShipmentArray = []; showPdfRenderer = false;">Close Label</p>
    </div>
  </div>
  <div v-if="((selectedShipmentArray.length > 5) && (selectedShipment == 'Current'))" class="button-container">
    <div class="count-selected">
        <p><span>{{selectedShipmentArray.length}}</span> shipment(s) selected.</p>
    </div>
  </div>
  <div v-if="((selectedShipmentArray.length > 5) && (selectedShipment == 'Current'))" class="button-container">
    <div class="print-selected">
        <p class="print-selected-text" @click="GetMergedPDFLabels()">Get Labels</p>
    </div>
  </div>
  <!-- <div class="label-container" v-if="labelData != null">
      <shipment-label :baseLabelData="labelData" />
  </div> -->


    <div class="label-container" v-if="(renderSignedLabelURLs.length > 0) && showPdfRenderer">
        <pdf-label-renderer :urls="this.renderSignedLabelURLs"/>
    </div>


  <div v-if="mergedLabelURL" class="merged-label-container">
    <div class="merged-anchor-container">
        <button @click="mergedLabelURL = null">
            Close label
        </button>
    </div>
    <!-- <iframe
    :src="mergedLabelURL"
    width="100%"
    height="600px"
    ></iframe> -->
    <pdf-label-renderer :urls="[this.mergedLabelURL]"/>
    <div class="count-selected">
        <p>A copy of this file was also sent to your email. <br><span>Email: </span>{{userData.userEmail}}</p>
    </div>
    <!-- <div class="merged-anchor-container">
        <a :href="mergedLabelURL" target="_blank">
            Open label in another window
        </a>
    </div> -->
  </div>
  <loading-charts v-if="loadingData" class="loading-charts"/>
  <!-- <table-filter 
  :filterByService="true" 
  :filterByReference="true" 
  :filterByCompanyName="true" 
  :filterByAddress="true" 
  :filterByCity="true"
  :filterByState="true"
  :filterByZipCode="true"
  :filterByShipmentID="true"
  :filterByDateRange="filterByDateRange"
  @filterValues="filterValues($event)"/> -->
  <open-search-table-filter 
  :filterByService="true" 
  :filterByReference="true" 
  :filterByCompanyName="true" 
  :filterByAddress="true" 
  :filterByPickupAddress="true"
  :filterByDeliveryInstructions="true"  
  :filterByDescription="true"
  :filterBySearchAll="true"
  :filterByCity="true"
  :filterByState="true"
  :filterByZipCode="true"
  :filterByShipmentID="true"
  :filterByCustomerName="true"
  :filterByDateRange="filterByDateRange"
  @filterValuesOpenSearch="filterValuesOpenSearch($event)"/>
  <div class="table-container-main">
    <div class="responsive-table">
        <div class="table-header" id="header">
            <div class="col-1">Shipment ID</div>
            <div class="col-2">Location</div>
            <div class="col-3">Service</div>
            <div class="col-4"><input v-if="selectedShipment == 'Current'" style="border: 0.15em solid #000; margin-left: 5px;" type="checkbox" name="" id="select-all-checkbox" @change="selectAllShipmentID($event)"></div>
            <!-- <div class="col-4"></div> -->
        </div>
        <loading-charts v-if="loadingTable" class="loading-charts"/>
        <div v-if="selectedShipment == 'Current'" class="table-row-container">
            <div class="table-row" v-for="(shipment, index) in currentShipments" :key="index">
                <div @click="trackShipment(shipment.shipmentID)" class="col-1"><p class="shipmentid-text" id="shipmentid-text">{{shipment.shipmentID}}</p></div>
                <div class="col-2 col-data"><span style="font-weight: bold;">{{shipment.serviceAddress.address.companyName}}</span> {{shipment.serviceAddress.address.address1}}, {{shipment.serviceAddress.address.city}}, {{shipment.serviceAddress.address.state}}, {{shipment.serviceAddress.address.zipCode}}</div>
                <div class="col-3 col-data"><p class="service-text">{{shipmentServiceType(shipment)}}</p></div>
                <!-- <div class="col-4"><input type="checkbox" name="" id="" :value="shipment.shipmentID" v-model="selectedShipmentArray" v-if="!shipment.service.includes('P2P')"></div> -->
                <div class="col-4"><input type="checkbox" name="" id="" :value="{ shipmentID: shipment.shipmentID, signedLabelURL: shipment.signedLabelURL }" v-model="selectedShipmentArray" v-if="!shipment.service.includes('P2P')"></div>
                <!--  && (selectedShipmentArray.length < 5 || selectedShipmentArray.some(item => item.shipmentID === shipment.shipmentID)) -->
            </div>
        </div>
        <div v-if="selectedShipment == 'In Transit'" class="table-row-container">
            <div class="table-row" v-for="(shipment, index) in inTransitShipments" :key="index">
                <div @click="trackShipment(shipment.shipmentID)" class="col-1"><p class="shipmentid-text" id="shipmentid-text">{{shipment.shipmentID}}</p></div>
                <div class="col-2 col-data"><span style="font-weight: bold;">{{shipment.serviceAddress.address.companyName}}</span> {{shipment.serviceAddress.address.address1}}, {{shipment.serviceAddress.address.city}}, {{shipment.serviceAddress.address.state}}, {{shipment.serviceAddress.address.zipCode}}</div>
                <div class="col-3 col-data"><p class="service-text">{{shipmentServiceType(shipment)}}</p></div>
                <div class="col-4"></div>
            </div>
        </div>
        <div v-if="selectedShipment == 'Delivered'" class="table-row-container">
            <div class="table-row" v-for="(shipment, index) in deliveredShipments" :key="index">
                <div @click="trackShipment(shipment.shipmentID)" class="col-1"><p class="shipmentid-text" id="shipmentid-text">{{shipment.shipmentID}}</p></div>
                <div class="col-2 col-data"><span style="font-weight: bold;">{{shipment.serviceAddress.address.companyName}}</span> {{shipment.serviceAddress.address.address1}}, {{shipment.serviceAddress.address.city}}, {{shipment.serviceAddress.address.state}}, {{shipment.serviceAddress.address.zipCode}}</div>
                <div class="col-3 col-data"><p class="service-text">{{shipmentServiceType(shipment)}}</p></div>
                <div class="col-4"></div>
            </div>
        </div>
        <div v-if="(inTransitShipments.length == 0) && (selectedShipment == 'In Transit')" class="table-row-container">
            <div class="table-row">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                <div class="col-2 col-data">No Shipments</div>
                <div class="col-3 col-data"><p class="service-text"></p></div>
                <div class="col-4"></div>
            </div>
        </div>
        <div v-if="(deliveredShipments.length == 0) && (selectedShipment == 'Delivered')" class="table-row-container">
            <div class="table-row">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                <div class="col-2 col-data">No Shipments</div>
                <div class="col-3 col-data"><p class="service-text"></p></div>
                <div class="col-4"></div>
            </div>
        </div>
        <div v-if="(currentShipments.length == 0) && (selectedShipment == 'Current')" class="table-row-container">
            <div class="table-row">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                <div class="col-2 col-data">No Shipments</div>
                <div class="col-3 col-data"><p class="service-text"></p></div>
                <div class="col-4"></div>
            </div>
        </div>
    </div>
  </div>
  <div class="button-container">
    <div class="print-selected close-label">
        <p class="print-selected-text download-csv" @click="downloadCSVTest()">Download CSV</p>
    </div>
  </div>
  

<shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :trackShipmentID="trackShipmentID" :cognitoUser="cognitoUser" :jwtToken="jwtToken" :userData="userData"/>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import ShipmentInfo from './ShipmentInfo.vue'
// import {emailMergedLabelsLREX, getMergedLabelsLREX, voidShipmentLambda} from '../../graphql/mutations' //filterCurrentShipments
import {emailMergedLabelsLREX, voidShipmentLambda} from '../../graphql/mutations' //filterCurrentShipments
// import ShipmentLabel from '../ShipmentDashboard/ShipmentLabel.vue'
import LoadingCharts from '../ShipmentDashboard/LoadingCharts.vue'
// import TableFilter from './TableFilter.vue'
import OpenSearchTableFilter from './OpenSearchTableFilter.vue'
import AlertUser from '../../components/Popups/AlertUser.vue';
import jsonexport from 'jsonexport'
import PdfLabelRenderer from './PdfLabelRenderer.vue';

export default {
    components:{
        ShipmentInfo,
        // ShipmentLabel,
        LoadingCharts,
        // TableFilter,
        OpenSearchTableFilter,
        AlertUser,
        PdfLabelRenderer
    },
    props: ['selectedShipment', 'selectedDates', 'userData', 'jwtToken', 'cognitoUser'],
    mounted(){
        this.toDate = new Date(new Date().setDate(new Date().getDate())).toJSON().slice(0, 10);
        this.fromDate =  new Date(new Date().setDate(new Date().getDate() - 7)).toJSON().slice(0, 10);
        this.sliderValue = 3;

        let previousMonthDate = new Date();
        // Set the current date to the first day of the current month
        previousMonthDate.setDate(1);
        // Subtract one day to get to the last day of the previous month
        previousMonthDate.setDate(0);
        this.previousMonth = previousMonthDate.toJSON().slice(0,7);
        this.currentMonth = this.toDate.slice(0,7);
    },
    watch:{
        'userData':function(){
            if(this.userData)
            {
                this.CurrentKey = this.userData.accountNo;
                this.getInTransitShipmentsGraphQL();
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user data to generate table."
            }
        },
        'selectedShipment'(newValue, oldValue){
            if(newValue != oldValue){
            if(this.selectedShipment == 'Current'){
                document.getElementById('header').style.backgroundColor = "#33f18a"
                this.selectedShipmentArray = [];
                this.currentShipments = []
                this.fromDate = this.selectedDates.fromDate; 
                this.toDate = this.selectedDates.toDate;
                this.sliderValue = this.selectedDates.sliderValue;
                // this.labelData = null;
                this.renderSignedLabelURLs = [];
                this.mergedLabelURL = null;
                this.getCurrentShipmentsGraphQL();
            }else if(this.selectedShipment == 'In Transit'){
                document.getElementById('header').style.backgroundColor = "#32ccfe"
                this.selectedShipmentArray = [];
                this.inTransitShipments = [];
                this.fromDate = this.selectedDates.fromDate; 
                this.toDate = this.selectedDates.toDate;
                this.sliderValue = this.selectedDates.sliderValue;
                // this.labelData = null;
                this.renderSignedLabelURLs = [];
                this.mergedLabelURL = null;
                this.getInTransitShipmentsGraphQL();
            }else if(this.selectedShipment == 'Delivered'){
                document.getElementById('header').style.backgroundColor = "#fe804d"
                this.selectedShipmentArray = [];
                this.deliveredShipments = [];
                this.fromDate = this.selectedDates.fromDate; 
                this.toDate = this.selectedDates.toDate;
                this.sliderValue = this.selectedDates.sliderValue;
                // this.labelData = null;
                this.renderSignedLabelURLs = [];
                this.mergedLabelURL = null;
                this.getDeliveredShipmentsGraphQL();
            }
            }
        },
        'selectedDates'(newValue, oldValue){
            let newDate = JSON.stringify(newValue);
            let oldDate = JSON.stringify(oldValue);
            if(newDate != oldDate){
                if(this.selectedShipment == 'Current'){
                    document.getElementById('header').style.backgroundColor = "#33f18a"
                    this.selectedShipmentArray = [];
                    this.currentShipments = []
                    this.fromDate = this.selectedDates.fromDate; 
                    this.toDate = this.selectedDates.toDate;
                    this.sliderValue = this.selectedDates.sliderValue;
                    // this.labelData = null;
                    this.renderSignedLabelURLs = [];
                    this.mergedLabelURL = null;
                    this.getCurrentShipmentsGraphQL();
                    this.filterValue = '';
                    this.filterField = '';
                }else if(this.selectedShipment == 'In Transit'){
                    document.getElementById('header').style.backgroundColor = "#32ccfe"
                    this.selectedShipmentArray = [];
                    this.inTransitShipments = [];
                    this.fromDate = this.selectedDates.fromDate; 
                    this.toDate = this.selectedDates.toDate;
                    this.sliderValue = this.selectedDates.sliderValue;
                    // this.labelData = null;
                    this.renderSignedLabelURLs = [];
                    this.mergedLabelURL = null;
                    this.getInTransitShipmentsGraphQL();
                    this.filterValue = '';
                    this.filterField = '';
                }else if(this.selectedShipment == 'Delivered'){
                    document.getElementById('header').style.backgroundColor = "#fe804d"
                    this.selectedShipmentArray = [];
                    this.deliveredShipments = [];
                    this.fromDate = this.selectedDates.fromDate; 
                    this.toDate = this.selectedDates.toDate;
                    this.sliderValue = this.selectedDates.sliderValue;
                    // this.labelData = null;
                    this.renderSignedLabelURLs = [];
                    this.mergedLabelURL = null;
                    this.getDeliveredShipmentsGraphQL();
                    this.filterValue = '';
                    this.filterField = '';
                }
            }
        }
    },
    data(){
        return{
            currentShipments: [],
            inTransitShipments: [],
            deliveredShipments: [],
            CurrentKey: null,
            trackShipmentID: null,
            toggleTrackShipment: false,
            user: null,
            fromDate: null,
            toDate: null,
            sliderValue: null,
            selectedShipmentArray: [],
            // labelData: null,
            loadingData: false,
            loadingTable: false,
            isFiltered: false,
            filterField: '',
            filterValue: '',
            toggleAlertBox: '',
            alertMessage: '',
            previousMonth: '',
            currentMonth: '',
            items: `items{
                    shipmentID
                    service
                    username
                    accountNo
                    ref1
                    ref2
                    ref3
                    ref4
                    ref5
                    description
                    deliveryInstructions
                    signedLabelURL
                    product{
                        productCode
                    }
                    serviceAddress{
                        address{
                        companyName
                        attention
                        address1
                        city
                        state
                        zipCode
                        }
                    }
                    deliveryPickup{
                        address{
                        companyName
                        address1
                        city
                        state
                        zipCode
                        }
                    }
                    additionalServices
                    updatedAt
                }`,
                deliveredCount: null,
                mergedLabelURL: null,
                renderSignedLabelURLs: [],
                showPdfRenderer: false
        }
    },
    computed:{
        filterByDateRange(){
            return this.selectedShipment === 'Delivered';
        }
    },
    methods:{
        shipmentServiceType(shipment){
            if(shipment.service == "SSLRLOC"){
                return "Standard"
            }else if(shipment.service == "PSLRLOC"){
                return "Priority"
            }else if(shipment.service == "SSLRPICK"){
                return "Pickup"
            }else{
                return shipment.service
            }
        },
        selectAllShipmentID(event) {
            const isChecked = event.target.checked;
            console.log(this.currentShipments)

            if (isChecked) {
                // User checked the box
                console.log('Checkbox is checked');
                this.selectedShipmentArray = this.currentShipments
                    .filter(item => !item.service.includes("P2P"))
                    // .slice(0, 5)
                    .map(item => ({
                        shipmentID: item.shipmentID,
                        signedLabelURL: item.signedLabelURL || null
                    }));
            } else {
                // User unchecked the box
                console.log('Checkbox is unchecked');
                this.selectedShipmentArray = [];
            }
            
            // if (this.selectedShipmentArray.length === 0) {
            //     this.selectedShipmentArray = this.currentShipments
            //         .filter(item => !item.service.includes("P2P"))
            //         // .slice(0, 5)
            //         .map(item => ({
            //             shipmentID: item.shipmentID,
            //             signedLabelURL: item.signedLabelURL || null
            //         }));
            // } else {
            //     this.selectedShipmentArray = [];
            // }
            console.log("Filtered Selected: ", this.selectedShipmentArray)
        },
        async getMonthsBetween(startDate, endDate) {
            const result = [];
            const start = new Date(startDate);
            const end = new Date(endDate);

            const startYear = start.getFullYear();
            const startMonth = start.getMonth();
            const endYear = end.getFullYear();
            const endMonth = end.getMonth();

            // Add start date (Ensure day doesn't exceed valid days of the month)
            let startDay = start.getDate() + 2;
            const startMaxDay = new Date(startYear, startMonth + 1, 0).getDate(); // Max days in the start month
            if (startDay > startMaxDay) {
                startDay = startMaxDay; // Set to the max valid day of the month
            }

            result.push({
                year: startYear,
                month: String(startMonth + 1).padStart(2, '0'),
                day: String(startDay).padStart(2, '0'),
                historyKey: `${this.CurrentKey}-${startYear}-${String(startMonth + 1).padStart(2, '0')}`
            });

            // Add full months in between
            let current = new Date(startYear, startMonth + 1, 1); // Start from the next month
            while (current.getFullYear() < endYear || (current.getFullYear() === endYear && current.getMonth() < endMonth)) {
                const year = current.getFullYear();
                const month = String(current.getMonth() + 1).padStart(2, '0');
                const maxDay = new Date(year, current.getMonth() + 1, 0).getDate(); // Max days in the month

                result.push({
                    year,
                    month,
                    day: String(maxDay).padStart(2, '0'), // Use max valid day for each month
                    historyKey: `${this.CurrentKey}-${year}-${month}`
                });
                current.setMonth(current.getMonth() + 1);
            }

            // Add end date (Ensure day doesn't exceed valid days of the month)
            let endDay = end.getDate() + 2;
            const endMaxDay = new Date(endYear, endMonth + 1, 0).getDate(); // Max days in the end month
            if (endDay > endMaxDay) {
                endDay = endMaxDay; // Set to the max valid day of the month
            }

            result.push({
                year: endYear,
                month: String(endMonth + 1).padStart(2, '0'),
                day: String(endDay).padStart(2, '0'),
                historyKey: `${this.CurrentKey}-${endYear}-${String(endMonth + 1).padStart(2, '0')}`
            });

            return result;
        },
        async filterValuesOpenSearch(event){
            const baseFilter = (event?.input?.filter) ?? {};

            if(this.selectedShipment == 'Current'){
                this.currentShipments = [];
                let cursor = null;
                let safeguard = 0; // Prevent crazy large amounts of calls

                do {
                    let finalEvent = {
                        ...event,
                        input: {
                            ...event.input,
                            ...(cursor ? { searchAfter: Array.isArray(cursor) ? JSON.stringify(cursor) : cursor } : {}),
                            filter: {
                                ...baseFilter,
                                exists: 'currentKey',
                                username: this.userData.userName,
                                accountNo: this.userData.accountNo
                            }
                        }
                    };

                    const { shipmentData, searchAfterValue, searchAfterJSON } =
                    await this.queryOpenSearchShipmentFilter(finalEvent);
                    if (Array.isArray(shipmentData) && shipmentData.length) {
                        this.currentShipments.push(...shipmentData);
                    }

                    let next = searchAfterValue;
                    if (!next && typeof searchAfterJSON === 'string') {
                        try { next = JSON.parse(searchAfterJSON); } catch { next = []; }
                    }

                    // stop when Lambda signals no more pages
                    if (!Array.isArray(next) || next.length === 0) break;

                    cursor = next;
                } while (++safeguard < 100);
            }else if(this.selectedShipment == 'In Transit'){
                this.inTransitShipments = [];
                let cursor = null;
                let safeguard = 0; // Prevent crazy large amounts of calls

                do {
                    let finalEvent = {
                        ...event,
                        input: {
                            ...event.input,
                            ...(cursor ? { searchAfter: Array.isArray(cursor) ? JSON.stringify(cursor) : cursor } : {}),
                            filter: {
                                ...baseFilter,
                                exists: 'inTransitKey',
                                username: this.userData.userName,
                                accountNo: this.userData.accountNo
                            }
                        }
                    };

                    const { shipmentData, searchAfterValue, searchAfterJSON } =
                    await this.queryOpenSearchShipmentFilter(finalEvent);
                    if (Array.isArray(shipmentData) && shipmentData.length) {
                        this.inTransitShipments.push(...shipmentData);
                    }

                    let next = searchAfterValue;
                    if (!next && typeof searchAfterJSON === 'string') {
                        try { next = JSON.parse(searchAfterJSON); } catch { next = []; }
                    }

                    // stop when Lambda signals no more pages
                    if (!Array.isArray(next) || next.length === 0) break;

                    cursor = next;
                } while (++safeguard < 100);
            }else if(this.selectedShipment == 'Delivered'){
                this.deliveredShipments = [];
                let cursor = null;
                let safeguard = 0; // Prevent crazy large amounts of calls

                do {
                    let finalEvent = {
                        ...event,
                        input: {
                            ...event.input,
                            ...(cursor ? { searchAfter: Array.isArray(cursor) ? JSON.stringify(cursor) : cursor } : {}),
                            filter: {
                                ...baseFilter,
                                exists: 'historyKey',
                                username: this.userData.userName,
                                accountNo: this.userData.accountNo
                            }
                        }
                    };

                    const { shipmentData, searchAfterValue, searchAfterJSON } =
                    await this.queryOpenSearchShipmentFilter(finalEvent);
                    if (Array.isArray(shipmentData) && shipmentData.length) {
                        this.deliveredShipments.push(...shipmentData);
                    }

                    let next = searchAfterValue;
                    if (!next && typeof searchAfterJSON === 'string') {
                        try { next = JSON.parse(searchAfterJSON); } catch { next = []; }
                    }

                    // stop when Lambda signals no more pages
                    if (!Array.isArray(next) || next.length === 0) break;

                    cursor = next;
                } while (++safeguard < 100);
                const dateRange = await this.getMonthsBetween(event.input.filter.updatedAt.gte, event.input.filter.updatedAt.lte)
                this.$emit('dateRangeDeliveredCount', {deliveredCount: this.deliveredShipments.length, deliveredRange: dateRange})
            }
        },
        async queryOpenSearchShipmentFilter(input) {
            this.loadingData = true;
            try {
                const { data } = await API.graphql({
                    query: `
                        mutation queryOpenSearchShipment($input: SearchInput!) {
                        queryOpenSearchShipment(input: $input) {
                            searchAfterValue
                            shipmentResult {
                                shipmentID
                                service
                                signedLabelURL
                                ref1
                                ref2
                                ref3
                                ref4
                                ref5
                                externalTrackingNumber
                                description
                                deliveryInstructions
                                product{
                                    productCode
                                }
                                updatedAt
                                accountNo
                                serviceAddress {
                                    address {
                                        attention
                                        companyName
                                        address1
                                        city
                                        state
                                        zipCode
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    variables: input,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                if (Array.isArray(data.errors) && data.errors.length) {
                    const msg = data.errors.map(e => e.message).join(" | ");
                    if (msg.includes("Response payload size exceeded")) {
                        this.toggleAlertBox = true;
                        this.alertMessage =
                        "Too many results to return at once. Please narrow your filters.";
                        return [];
                    }
                    // Other Error in request
                    this.toggleAlertBox = true;
                    this.alertMessage = msg || "Error in request.";
                    return [];
                }

                const shipments = data?.queryOpenSearchShipment?.shipmentResult ?? [];
                const searchAfter = data?.queryOpenSearchShipment?.searchAfterValue ?? [];

                return{
                    shipmentData: shipments,
                    searchAfterJSON: searchAfter
                }
            } catch (err) {
                console.error(err);
                const msg =
                    err?.errors?.[0]?.message || err?.message || String(err || "");
                    if (msg.includes("Response payload size exceeded")) {
                    this.toggleAlertBox = true;
                    this.alertMessage =
                        "Too many results to return at once. Please narrow your filters.";
                    return [];
                }
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting filtered shipments";
                return [];
            } finally {
                this.loadingData = false;
            }
        },
        async getCurrentShipmentsGraphQL() {
            this.loadingTable = true;
            let graphqlQuery;
            this.currentShipments = [];
            let currentArray = [];
            let userName;
            let nextToken = null;
            userName = this.userData.userName;

            do {
                if (this.isFiltered == true) {
                    graphqlQuery = `query shipmentByCurrentKey {
                        shipmentByCurrentKey(currentKey: "${this.CurrentKey}", username: {eq: "${userName}"}, filter: {${this.filterField}: {eq: "${this.filterValue}"}}, limit: 1000, nextToken: ${nextToken ? `"${nextToken}"` : null}) {
                            ${this.items}
                            nextToken
                        }
                    }`;
                } else {
                    graphqlQuery = `query shipmentByCurrentKey {
                        shipmentByCurrentKey(currentKey: "${this.CurrentKey}", username: {eq: "${userName}"}, limit: 1000, nextToken: ${nextToken ? `"${nextToken}"` : null}) {
                            ${this.items}
                            nextToken
                        }
                    }`;
                }
                
                try {
                    let shipmentByCurrentKey = await API.graphql({
                        query: graphqlQuery,
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    currentArray = currentArray.concat(shipmentByCurrentKey.data.shipmentByCurrentKey.items);
                    nextToken = shipmentByCurrentKey.data.shipmentByCurrentKey.nextToken;

                } catch (e) {
                    console.log(e);
                    if (e) {
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error getting current shipments";
                    }
                }
            } while (nextToken);

            this.currentShipments = currentArray;

            this.loadingTable = false;
            this.isFiltered = false;
        },
        async getInTransitShipmentsGraphQL() {
            this.loadingTable = true;
            let graphqlQuery;
            let inTransitArray = [];
            let userName;
            let nextToken = null;
            userName = this.userData.userName;

            do {
                if (this.isFiltered == true) {
                    graphqlQuery = `query shipmentByInTransitKey {
                        shipmentByInTransitKey(inTransitKey: "${this.CurrentKey}", username: {eq: "${userName}"}, filter: {${this.filterField}: {eq: "${this.filterValue}"}}, limit: 1000, nextToken: ${nextToken ? `"${nextToken}"` : null}) {
                            ${this.items}
                            nextToken
                        }
                    }`;
                } else {
                    graphqlQuery = `query shipmentByInTransitKey {
                        shipmentByInTransitKey(inTransitKey: "${this.CurrentKey}", username: {eq: "${userName}"}, limit: 1000, nextToken: ${nextToken ? `"${nextToken}"` : null}) {
                            ${this.items}
                            nextToken
                        }
                    }`;
                }

                try {
                    this.inTransitShipments = [];
                    let shipmentByInTransitKey = await API.graphql({
                        query: graphqlQuery,
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    inTransitArray = inTransitArray.concat(shipmentByInTransitKey.data.shipmentByInTransitKey.items);
                    nextToken = shipmentByInTransitKey.data.shipmentByInTransitKey.nextToken;

                } catch (e) {
                    console.log(e);
                    if (e) {
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error getting in transit shipments";
                    }
                }
            } while (nextToken);

            this.inTransitShipments = inTransitArray;
           
            this.loadingTable = false;
            this.isFiltered = false;
        },
        async getDeliveredShipmentsGraphQL() {
            this.deliveredShipments = [];
            this.loadingTable = true;
            let HistoryKey = this.CurrentKey + '-' + this.toDate.slice(0, 7);
            let DeliveryDayTo = this.toDate.slice(8, 10);
            let DeliveryDayFrom = this.fromDate.slice(8, 10);
            let deliveredArray = [];
            let deliveredArrayPrev = [];
            let userName = this.userData.userName;

            const fetchAllData = async (graphqlQuery, itemsArray = [], nextToken = null) => {
                try {
                    const result = await API.graphql({
                        query: graphqlQuery(nextToken),
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });
                    const newItems = result.data.shipmentByHistoryKey.items;
                    itemsArray.push(...newItems);

                    const token = result.data.shipmentByHistoryKey.nextToken;
                    if (token) {
                        // Recursive call to fetch next page of results
                        await fetchAllData(graphqlQuery, itemsArray, token);
                    }
                } catch (e) {
                    console.log(e);
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting delivered shipments";
                }
                return itemsArray;
            };

            try {
                switch (this.sliderValue) {
                    case 1:{
                        const currentMonthQuery = (nextToken = null) => `
                            query shipmentByHistoryKey {
                                shipmentByHistoryKey(
                                    historyKey: "${HistoryKey}", 
                                    usernameDeliveryDay: {eq: {deliveryDay: "${DeliveryDayTo}", username: "${userName}"}},
                                    ${this.isFiltered ? `filter: {${this.filterField}: {eq: "${this.filterValue}"}}` : ''}, 
                                    limit: 1000,
                                    nextToken: ${nextToken ? `"${nextToken}"` : null}
                                ) {
                                    ${this.items}
                                    nextToken
                                }
                            }
                        `;

                        this.deliveredShipments = await fetchAllData(currentMonthQuery);
                        
                        break;
                    }
                    case 2:{
                        if (DeliveryDayFrom > DeliveryDayTo) {
                            const previousMonthDate = new Date();
                            previousMonthDate.setDate(1);
                            previousMonthDate.setDate(0);
                            const numberOfDays = previousMonthDate.getDate();
                            let previousMonthHistoryKey = this.CurrentKey + "-" + this.fromDate.slice(0, 7);

                            const filteredQuery = (nextToken = null) => `
                                query shipmentByHistoryKey {
                                    shipmentByHistoryKey(
                                        historyKey: "${previousMonthHistoryKey}", 
                                        filter: {${this.filterField}: {eq: "${this.filterValue}"}}, 
                                        usernameDeliveryDay: {between: [{deliveryDay: "${DeliveryDayFrom}", username: "${userName}"},{deliveryDay: "${numberOfDays}", username: "${userName}"}]},
                                        limit: 1000,
                                        nextToken: ${nextToken ? `"${nextToken}"` : null}
                                    ) {
                                        ${this.items}
                                        nextToken
                                    }
                                }
                            `;

                            const filteredQueryCurrentMonth = (nextToken = null) => `
                                query shipmentByHistoryKey {
                                    shipmentByHistoryKey(
                                        historyKey: "${HistoryKey}", 
                                        filter: {${this.filterField}: {eq: "${this.filterValue}"}}, 
                                        usernameDeliveryDay: {between: [{deliveryDay: "00", username: "${userName}"},{deliveryDay: "${DeliveryDayTo}", username: "${userName}"}]},
                                        limit: 1000,
                                        nextToken: ${nextToken ? `"${nextToken}"` : null}
                                    ) {
                                        ${this.items}
                                        nextToken
                                    }
                                }
                            `;

                            const nonFilteredQuery = (nextToken = null) => `
                                query shipmentByHistoryKey {
                                    shipmentByHistoryKey(
                                        historyKey: "${previousMonthHistoryKey}",
                                        usernameDeliveryDay: {between: [{deliveryDay: "${DeliveryDayFrom}", username: "${userName}"},{deliveryDay: "${numberOfDays}", username: "${userName}"}]}, 
                                        limit: 1000,
                                        nextToken: ${nextToken ? `"${nextToken}"` : null}
                                    ) {
                                        ${this.items}
                                        nextToken
                                    }
                                }
                            `;

                            const nonFilteredQueryCurrentMonth = (nextToken = null) => `
                                query shipmentByHistoryKey {
                                    shipmentByHistoryKey(
                                        historyKey: "${HistoryKey}", 
                                        usernameDeliveryDay: {between: [{deliveryDay: "00", username: "${userName}"},{deliveryDay: "${DeliveryDayTo}", username: "${userName}"}]},
                                        limit: 1000,
                                        nextToken: ${nextToken ? `"${nextToken}"` : null}
                                    ) {
                                        ${this.items}
                                        nextToken
                                    }
                                }
                            `;

                            deliveredArrayPrev = await fetchAllData(
                                this.isFiltered ? filteredQuery : nonFilteredQuery
                            );

                            deliveredArray = await fetchAllData(
                                this.isFiltered ? filteredQueryCurrentMonth : nonFilteredQueryCurrentMonth
                            );

                            this.deliveredShipments = deliveredArray.concat(deliveredArrayPrev);
                        } else {
                            const currentMonthQuery = (nextToken = null) => `
                                query shipmentByHistoryKey {
                                    shipmentByHistoryKey(
                                        historyKey: "${HistoryKey}", 
                                        usernameDeliveryDay: {between: [{deliveryDay: "00", username: "${userName}"},{deliveryDay: "${DeliveryDayTo}", username: "${userName}"}]},
                                        ${this.isFiltered ? `filter: {${this.filterField}: {eq: "${this.filterValue}"}}` : ''}, 
                                        limit: 1000,
                                        nextToken: ${nextToken ? `"${nextToken}"` : null}
                                    ) {
                                        ${this.items}
                                        nextToken
                                    }
                                }
                            `;

                            this.deliveredShipments = await fetchAllData(currentMonthQuery);
                        }
                        break;
                    }
                    case 3: {
                        const now = new Date();
                        const yearNow = now.getUTCFullYear();
                        const monthNow = String(now.getUTCMonth() + 1).padStart(2, "0");
                        const dayNow = String(now.getUTCDate()).padStart(2, "0");

                        // 30 days ago
                        const past = new Date();
                        past.setUTCDate(past.getUTCDate() - 30);
                        const yearPast = past.getUTCFullYear();
                        const monthPast = String(past.getUTCMonth() + 1).padStart(2, "0");
                        const dayPast = String(past.getUTCDate()).padStart(2, "0");

                        const accountNo = this.CurrentKey;

                        const historyKeyNow = `${accountNo}-${yearNow}-${monthNow}`;
                        const historyKeyPast = `${accountNo}-${yearPast}-${monthPast}`;

                        console.log("Today:", yearNow, monthNow, dayNow, historyKeyNow);
                        console.log("30 days ago:", yearPast, monthPast, dayPast, historyKeyPast);

                        if(monthNow == monthPast){
                            const currentMonthQuery = (nextToken = null) => `
                                query shipmentByHistoryKey {
                                    shipmentByHistoryKey(
                                        historyKey: "${historyKeyNow}", 
                                        usernameDeliveryDay: {between: [{deliveryDay: "${dayPast}", username: "${userName}"},{deliveryDay: "${dayNow}", username: "${userName}"}]},
                                        ${this.isFiltered ? `filter: {${this.filterField}: {eq: "${this.filterValue}"}}` : ''}, 
                                        limit: 1000,
                                        nextToken: ${nextToken ? `"${nextToken}"` : null}
                                    ) {
                                        ${this.items}
                                        nextToken
                                    }
                                }
                            `;
                            this.deliveredShipments = await fetchAllData(currentMonthQuery);
                        }else{
                            const pastMonthQuery = (nextToken = null) => `
                                query shipmentByHistoryKey {
                                    shipmentByHistoryKey(
                                        historyKey: "${historyKeyPast}", 
                                        usernameDeliveryDay: {between: [{deliveryDay: "${dayPast}", username: "${userName}"},{deliveryDay: "31", username: "${userName}"}]},
                                        ${this.isFiltered ? `filter: {${this.filterField}: {eq: "${this.filterValue}"}}` : ''}, 
                                        limit: 1000,
                                        nextToken: ${nextToken ? `"${nextToken}"` : null}
                                    ) {
                                        ${this.items}
                                        nextToken
                                    }
                                }
                            `;

                            const currentMonthQuery = (nextToken = null) => `
                                query shipmentByHistoryKey {
                                    shipmentByHistoryKey(
                                        historyKey: "${historyKeyNow}", 
                                        usernameDeliveryDay: {between: [{deliveryDay: "00", username: "${userName}"},{deliveryDay: "${dayNow}", username: "${userName}"}]},
                                        ${this.isFiltered ? `filter: {${this.filterField}: {eq: "${this.filterValue}"}}` : ''}, 
                                        limit: 1000,
                                        nextToken: ${nextToken ? `"${nextToken}"` : null}
                                    ) {
                                        ${this.items}
                                        nextToken
                                    }
                                }
                            `;

                            const [pastItems, currentItems] = await Promise.all([
                                fetchAllData(pastMonthQuery),
                                fetchAllData(currentMonthQuery),
                            ]);
                            this.deliveredShipments = pastItems.concat(currentItems);
                        }

                        // const currentMonthQuery = (nextToken = null) => `
                        //     query shipmentByHistoryKey {
                        //         shipmentByHistoryKey(
                        //             historyKey: "${HistoryKey}", 
                        //             usernameDeliveryDay: {between: [{deliveryDay: "00", username: "${userName}"},{deliveryDay: "31", username: "${userName}"}]},
                        //             ${this.isFiltered ? `filter: {${this.filterField}: {eq: "${this.filterValue}"}}` : ''}, 
                        //             limit: 1000,
                        //             nextToken: ${nextToken ? `"${nextToken}"` : null}
                        //         ) {
                        //             ${this.items}
                        //             nextToken
                        //         }
                        //     }
                        // `;
                        // this.deliveredShipments = await fetchAllData(currentMonthQuery);
                        break;
                    }
                    default:
                        break;
                }
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting delivered shipments";
            } finally {
                this.loadingTable = false;
                this.isFiltered = false;
            }
        },
        async GetMergedPDFLabels(){
            this.loadingData = true;
            this.renderSignedLabelURLs = [];
            const signedLabelURLs = this.selectedShipmentArray
            .filter(item => item.signedLabelURL)
            .map(item => item.signedLabelURL);
            console.log(signedLabelURLs)
    
            try{
                let shipmentLabels = await API.graphql({
                query:  emailMergedLabelsLREX,
                variables:{ input:{ pdfUrls: signedLabelURLs, userEmail: this.userData.userEmail } },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log(shipmentLabels)
                this.mergedLabelURL = shipmentLabels.data.emailMergedLabelsLREX.downloadUrl;
                //this.labelData = "data:application/pdf;base64, " + shipmentLabels.data.getMergedLabelsLREX.mergedPDF;
            }catch(e){
                console.log(e);

                // Check for Lambda timeout error
                const timeoutError = e.errors?.some(
                    err => err.errorType === "Lambda:ExecutionTimeoutException"
                );

                if (timeoutError) {
                    this.toggleAlertBox = true;
                    this.alertMessage = "This process takes a bit of time. You will receive an email with the merged labels shortly. <br> <span style='font-weight: bold;'>Email sent to: <span/>" + this.userData.userEmail ;
                } else {
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting merged shipment label.";
                }
            }finally{
                this.loadingData = false;
                this.selectedShipmentArray = [];
                const checkbox = document.getElementById("select-all-checkbox");
                checkbox.checked = false;
            }
        },
        async PrintLabel(){
            // this.loadingData = true;
            this.showPdfRenderer = false;
            this.mergedLabelURL = null;
            const signedLabelURLs = this.selectedShipmentArray
            .filter(item => item.signedLabelURL)
            .map(item => item.signedLabelURL);
            console.log(signedLabelURLs)

            if(signedLabelURLs.length > 0){
                this.renderSignedLabelURLs = signedLabelURLs;
                this.showPdfRenderer = true;
            }

            // this.loadingData = false;
            // try{
            //     let shipmentLabels = await API.graphql({
            //     query:  getMergedLabelsLREX,
            //     variables:{ input:{ pdfUrls: signedLabelURLs } },
            //     authMode: "AMAZON_COGNITO_USER_POOLS",
            //     })
            //     this.labelData = "data:application/pdf;base64, " + shipmentLabels.data.getMergedLabelsLREX.mergedPDF;
            // }catch(e){
            //     console.log(e)
            //     if(e){
            //         this.toggleAlertBox = true;
            //         this.alertMessage = "Error getting shipment label."
            //     }
            // }finally{
            //     this.loadingData = false;
            // }
        },
        async VoidShipment() {
            this.loadingData = true;
            try {
                // Map each element in selectedShipmentArray to a voidShipment call
                const shipmentPromises = this.selectedShipmentArray.map((element) => {
                    const input = {
                        input: {
                            shipmentID: element.shipmentID,
                            username: this.userData.userName
                        }
                    };
                    return API.graphql({
                        query: voidShipmentLambda,
                        variables: input,
                        authMode: "AMAZON_COGNITO_USER_POOLS"
                    });
                });

                const responses = await Promise.all(shipmentPromises);
                responses.forEach((response) => {
                    console.log(response);
                });
                this.finalizeVoidProcess();
            } catch (error) {
                console.log(error);
                this.alertMessage = "Error voiding shipments";
                this.toggleAlertBox = true;
                this.finalizeVoidProcess();
            }
        },
        finalizeVoidProcess() {
            this.loadingData = false;
            this.selectedShipmentArray = [];
            this.fromDate = this.selectedDates.fromDate; 
            this.toDate = this.selectedDates.toDate;
            this.getCurrentShipmentsGraphQL();
            this.$emit('refreshAfterVoid', true);
        },
        closeLabel(){
            const checkbox = document.getElementById('select-all-checkbox');
            if (checkbox) {
                checkbox.checked = false;
            }
        },
        trackShipment(shipmentID){
            this.toggleTrackShipment = true;
            this.trackShipmentID = shipmentID;
        },
        closeShipmentInfo(event){
            if(this.selectedShipment == 'In Transit'){
                this.getInTransitShipmentsGraphQL();
                this.$emit('refreshAfterVoid', true);
            }
            this.toggleTrackShipment = event;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async downloadCSVTest(){
            this.loadingTable = true;
            let csvArray;

            if (this.selectedShipment == 'Current') {
                csvArray = this.currentShipments.map(obj =>{
                    const productCode = obj?.product?.[0]?.productCode ?? "ERROR";
                    return {
                        shipmentID: obj.shipmentID,
                        Service: obj.service,
                        AccountNo: obj.accountNo,
                        DeliveryCompanyName: obj.serviceAddress.address.companyName,
                        DeliveryAddress1: obj.serviceAddress.address.address1,
                        DeliveryAddress2: obj.serviceAddress.address.address2,
                        DeliveryCity: obj.serviceAddress.address.city,
                        DeliveryState: obj.serviceAddress.address.state,
                        DeliveryZipCode: obj.serviceAddress.address.zipCode,
                        ...(obj?.deliveryPickup?.address?.companyName && {
                            PickupCompanyName: obj.deliveryPickup.address.companyName
                        }),
                        ...(obj?.deliveryPickup?.address?.address1 && {
                            PickupAddress1: obj.deliveryPickup.address.address1
                        }),
                        ...(obj?.deliveryPickup?.address?.address2 && {
                            PickupAddress2: obj.deliveryPickup.address.address2
                        }),
                        ...(obj?.deliveryPickup?.address?.city && {
                            PickupCity: obj.deliveryPickup.address.city
                        }),
                        ...(obj?.deliveryPickup?.address?.state && {
                            PickupState: obj.deliveryPickup.address.state
                        }),
                        ...(obj?.deliveryPickup?.address?.zipCode && {
                            PickupZipCode: obj.deliveryPickup.address.zipCode
                        }),

                        ...(obj?.serviceAddress?.address?.attention && {
                            Attention: obj.serviceAddress.address.attention
                        }),
                         ...(obj?.ref1 && {
                            Ref1: obj.ref1
                        }),
                        ...(obj?.ref2 && {
                            Ref2: obj.ref2
                        }),
                        ...(obj?.ref3 && {
                            Ref3: obj.ref3
                        }),
                        ...(obj?.ref4 && {
                            Ref4: obj.ref4
                        }),
                        ...(obj?.ref5 && {
                            Ref5: obj.ref5
                        }),
                        ...(obj?.deliveryInstructions && {
                            DeliveryInstructions: obj.deliveryInstructions
                        }),
                        ...(obj?.description && {
                            Description: obj.description
                        }),
                        ProductCode: productCode
                    }
                })
                jsonexport(csvArray, (error, csv) => {
                    if (error) {
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error downloading current shipments"
                    }
                    const blob = new Blob([csv], { type: 'text/csv' });
                    const anchor = document.createElement('a');
                    anchor.href = window.URL.createObjectURL(blob);
                    anchor.download = 'CurrentShipments.csv';
                    anchor.click();
                    window.URL.revokeObjectURL(anchor.href);
                    anchor.remove();
                    this.loadingTable = false;
                })
            }else if(this.selectedShipment == 'In Transit'){
                csvArray = this.inTransitShipments.map(obj =>{
                    const productCode = obj?.product?.[0]?.productCode ?? "ERROR";
                    return {
                        shipmentID: obj.shipmentID,
                        Service: obj.service,
                        AccountNo: obj.accountNo,
                        DeliveryCompanyName: obj.serviceAddress.address.companyName,
                        DeliveryAddress1: obj.serviceAddress.address.address1,
                        DeliveryAddress2: obj.serviceAddress.address.address2,
                        DeliveryCity: obj.serviceAddress.address.city,
                        DeliveryState: obj.serviceAddress.address.state,
                        DeliveryZipCode: obj.serviceAddress.address.zipCode,
                        ...(obj?.deliveryPickup?.address?.companyName && {
                            PickupCompanyName: obj.deliveryPickup.address.companyName
                        }),
                        ...(obj?.deliveryPickup?.address?.address1 && {
                            PickupAddress1: obj.deliveryPickup.address.address1
                        }),
                        ...(obj?.deliveryPickup?.address?.address2 && {
                            PickupAddress2: obj.deliveryPickup.address.address2
                        }),
                        ...(obj?.deliveryPickup?.address?.city && {
                            PickupCity: obj.deliveryPickup.address.city
                        }),
                        ...(obj?.deliveryPickup?.address?.state && {
                            PickupState: obj.deliveryPickup.address.state
                        }),
                        ...(obj?.deliveryPickup?.address?.zipCode && {
                            PickupZipCode: obj.deliveryPickup.address.zipCode
                        }),
                        
                        ...(obj?.serviceAddress?.address?.attention && {
                            Attention: obj.serviceAddress.address.attention
                        }),
                         ...(obj?.ref1 && {
                            Ref1: obj.ref1
                        }),
                        ...(obj?.ref2 && {
                            Ref2: obj.ref2
                        }),
                        ...(obj?.ref3 && {
                            Ref3: obj.ref3
                        }),
                        ...(obj?.ref4 && {
                            Ref4: obj.ref4
                        }),
                        ...(obj?.ref5 && {
                            Ref5: obj.ref5
                        }),
                        ...(obj?.deliveryInstructions && {
                            DeliveryInstructions: obj.deliveryInstructions
                        }),
                        ...(obj?.description && {
                            Description: obj.description
                        }),
                        ProductCode: productCode
                    }
                })
                jsonexport(csvArray, (error, csv) => {
                    if (error) {
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error downloading in transit shipments"
                    }
                    const blob = new Blob([csv], { type: 'text/csv' });
                    const anchor = document.createElement('a');
                    anchor.href = window.URL.createObjectURL(blob);
                    anchor.download = 'InTransitShipments.csv';
                    anchor.click();
                    window.URL.revokeObjectURL(anchor.href);
                    anchor.remove();
                    this.loadingTable = false;
                })
            }else if(this.selectedShipment == 'Delivered'){
                csvArray = this.deliveredShipments.map(obj =>{
                    const productCode = obj?.product?.[0]?.productCode ?? "ERROR";
                    let date;
                    const updateDate = obj?.updatedAt ?? "ERROR"
                    if(updateDate !== "ERROR"){
                        const newDate = new Date(updateDate)
                        date = newDate
                    }else{
                        date = updateDate
                    }
                    return {
                        shipmentID: obj.shipmentID,
                        Service: obj.service,
                        AccountNo: obj.accountNo,
                        DeliveryCompanyName: obj.serviceAddress.address.companyName,
                        DeliveryAddress1: obj.serviceAddress.address.address1,
                        DeliveryAddress2: obj.serviceAddress.address.address2,
                        DeliveryCity: obj.serviceAddress.address.city,
                        DeliveryState: obj.serviceAddress.address.state,
                        DeliveryZipCode: obj.serviceAddress.address.zipCode,
                        ...(obj?.deliveryPickup?.address?.companyName && {
                            PickupCompanyName: obj.deliveryPickup.address.companyName
                        }),
                        ...(obj?.deliveryPickup?.address?.address1 && {
                            PickupAddress1: obj.deliveryPickup.address.address1
                        }),
                        ...(obj?.deliveryPickup?.address?.address2 && {
                            PickupAddress2: obj.deliveryPickup.address.address2
                        }),
                        ...(obj?.deliveryPickup?.address?.city && {
                            PickupCity: obj.deliveryPickup.address.city
                        }),
                        ...(obj?.deliveryPickup?.address?.state && {
                            PickupState: obj.deliveryPickup.address.state
                        }),
                        ...(obj?.deliveryPickup?.address?.zipCode && {
                            PickupZipCode: obj.deliveryPickup.address.zipCode
                        }),
                        ...(obj?.serviceAddress?.address?.attention && {
                            Attention: obj.serviceAddress.address.attention
                        }),
                         ...(obj?.ref1 && {
                            Ref1: obj.ref1
                        }),
                        ...(obj?.ref2 && {
                            Ref2: obj.ref2
                        }),
                        ...(obj?.ref3 && {
                            Ref3: obj.ref3
                        }),
                        ...(obj?.ref4 && {
                            Ref4: obj.ref4
                        }),
                        ...(obj?.ref5 && {
                            Ref5: obj.ref5
                        }),
                        ...(obj?.deliveryInstructions && {
                            DeliveryInstructions: obj.deliveryInstructions
                        }),
                        ...(obj?.description && {
                            Description: obj.description
                        }),
                        ProductCode: productCode,
                        Date: date
                    }
                })
                jsonexport(csvArray, (error, csv) => {
                    if (error) {
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error downloading delivered shipments"
                    }
                    const blob = new Blob([csv], { type: 'text/csv' });
                    const anchor = document.createElement('a');
                    anchor.href = window.URL.createObjectURL(blob);
                    anchor.download = 'Delivered.csv';
                    anchor.click();
                    window.URL.revokeObjectURL(anchor.href);
                    anchor.remove();
                    this.loadingTable = false;
            })
            }
        }
    }
}
</script>

<style scoped>
.table-container-main {
	width: 100%;
	margin-top: 0;
	overflow-x: hidden;
	resize: both;
	height: 350px
}

.responsive-table {
	width: 100%
}

* {
	scrollbar-width: auto;
	scrollbar-color: #f3f3f3 #fff
}

::-webkit-scrollbar {
	width: 16px
}

::-webkit-scrollbar-track {
	background: #fff
}

::-webkit-scrollbar-thumb {
	background-color: #f3f3f3;
	border-radius: 10px;
	border: 3px solid #fff
}

.table-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #32ccfe;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px;
	color: #fff;
	position: sticky;
	top: 0
}

.table-row-container {
	height: 100%;
	overflow-y: auto;
	border-radius: 5px;
	width: 100%;
	animation: animate-table-row 1s ease
}

@keyframes animate-table-row {
	from {
		margin-left: -50px
	}

	to {
		margin-left: 0
	}
}

.table-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #f3f3f3;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px
}

.table-header .col-1 {
	margin-right: 5px
}

.col-1 {
	flex-basis: 20%;
	text-align: left;
	white-space: nowrap
}

.col-2 {
	flex-basis: 40%;
	text-align: left;
	margin-left: 5px
}

.col-3 {
	flex-basis: 30%;
	text-align: left;
	margin-left: 5px
}

.col-data {
	text-align: left
}

.col-4 {
	flex-basis: 10%;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center
}

.service-text {
	background-color: #d4d4d4;
	padding: 2.5px 10px;
	border-radius: 999px;
	width: fit-content;
	margin: 0;
	font-size: 12px
}

.shipmentid-text {
	margin: 0;
	color: #6a6a6a;
	width: fit-content;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.shipmentid-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

input[type=checkbox] {
	-webkit-appearance: none;
	appearance: none;
	background-color: #fff;
	margin: 0;
	cursor: pointer;
	font: inherit;
	color: #33f18a;
	width: 1.05em;
	height: 1.05em;
	border: .15em solid #33f18a;
	border-radius: .15em;
	display: grid;
	place-content: center;
	transition-duration: .5s
}

input[type=checkbox]:hover {
	background-color: #f3f3f3;
	transition-duration: .5s
}

input[type=checkbox]::before {
	content: "";
	width: .65em;
	height: .65em;
	clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);
	transform: scale(0);
	transform-origin: bottom left;
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em var(--form-control-color);
	background-color: CanvasText
}

input[type=checkbox]:checked::before {
	transform: scale(1)
}

.button-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	margin: 0;
	animation: animate-table-row 1s ease
}

.print-selected-text {
	margin: 0;
	margin-bottom: 5px;
	margin-right: 5px;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.download-csv {
	margin-top: 5px
}

.void-selected-text {
	margin: 0;
	margin-bottom: 5px;
	padding: 2.5px 10px;
	margin-bottom: 5px;
	border-radius: 999px;
	background-color: #fe804d;
	border: 1px solid #ff5512;
	color: #fff;
	transition-duration: .5s
}

.print-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.void-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.count-selected{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: -moz-fit-content;
    width: fit-content;
    background-color: #e2e2e2;
    padding: 5px 15px;
    border-radius: 999px;
    margin-bottom: 5px;
}

.count-selected p{
    margin: 0;
    text-align: left;
}

.count-selected span{
    font-weight: bold;
}

.close-label {
	margin-left: auto
}

.label-container {
	width: 100%
}

.merged-label-container{
    width: 100%;
}

.merged-label-container iframe{
    border-radius: 25px;
}

.merged-anchor-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 0;
    animation: animate-table-row 1s ease;
}

.merged-label-container a,
.merged-label-container button {
  margin: 0;
  margin-bottom: 5px;
  margin-right: 5px;
  margin-top: 5px;
  padding: 2.5px 10px;
  border-radius: 999px;
  background-color: #f3f3f3;
  border: 1px solid #a0a0a0;
  transition-duration: 0.5s;
  text-decoration: none;
  color: #000;
}

.merged-label-container a:hover,
.merged-label-container button:hover {
  filter: brightness(0.9);
  cursor: pointer;
  transition-duration: 0.5s;
}

@media only screen and (max-width:600px) {
	.service-text {
		font-size: 8px
	}
}

@media only screen and (max-width:1135px) {
	.col-1 {
		min-width: 30%
	}
}
</style>